<template>
    <div>
        <h1>cabinetProfile</h1>
    </div>
</template>

<script>
export default {
    name: "cabinetProfile",
    data(){
        return {
            product: '',
        }
    },
    components: {
    },
    computed: {
    },
    mounted() {
    }
};
</script>

<style lang="scss">
</style>
